// augmented-ui core must precede any stylesheet that sets --aug-* properties
// (application.css, component styles); the inkpunk mixins rely on cascade
// order and must come after the core.
import '../../../vendor/inkpunk-ui/aug-core.min.css';
import '../../../vendor/inkpunk-ui/inkpunk-mixins.min.css';
// Build-time jittered silhouettes per shape, keyed by data-ink-seed
// (config/vite/inkpunk-variants.js + lib/ink.js).
import 'virtual:inkpunk-variants.css';
import 'virtual:uno.css';
import './application.css';

import { createInertiaApp } from '@inertiajs/svelte';
import { mount } from 'svelte';

createInertiaApp({
  progress: true,
  // Rails sets an XSRF-TOKEN cookie (ApplicationController#set_csrf_cookie);
  // Inertia's HTTP client echoes it back under this header, which Rails verifies
  // as its default CSRF header. Closes the loop without custom header parsing.
  http: {
    xsrfHeaderName: 'X-CSRF-Token',
  },
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.svelte', { eager: true })
    return pages[`../pages/${name}.svelte`]
  },

  setup({ el, App, props }) {
    mount(App, { target: el, props });
  },
})
